import { render, staticRenderFns } from "./BrickSettingsAudience.vue?vue&type=template&id=9470a30a&scoped=true&"
import script from "./BrickSettingsAudience.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9470a30a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9470a30a')) {
      api.createRecord('9470a30a', component.options)
    } else {
      api.reload('9470a30a', component.options)
    }
    module.hot.accept("./BrickSettingsAudience.vue?vue&type=template&id=9470a30a&scoped=true&", function () {
      api.rerender('9470a30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Audience/BrickSettingsAudience.vue"
export default component.exports